"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[279],{

/***/ 94279:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YI": function() { return /* binding */ PortableText; }
});

// UNUSED EXPORTS: PortableTextComponentsProvider, defaultComponents, mergeComponents, toPlainText

;// CONCATENATED MODULE: ./node_modules/@portabletext/toolkit/dist/portable-text-toolkit.mjs
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function isPortableTextSpan(node) {
  return node._type === "span" && "text" in node && typeof node.text === "string" && (typeof node.marks === "undefined" || Array.isArray(node.marks) && node.marks.every((mark) => typeof mark === "string"));
}
function isPortableTextBlock(node) {
  return typeof node._type === "string" && node._type[0] !== "@" && (!("markDefs" in node) || Array.isArray(node.markDefs) && node.markDefs.every((def) => typeof def._key === "string")) && "children" in node && Array.isArray(node.children) && node.children.every((child) => typeof child === "object" && "_type" in child);
}
function isPortableTextListItemBlock(block) {
  return isPortableTextBlock(block) && "listItem" in block && typeof block.listItem === "string" && (typeof block.level === "undefined" || typeof block.level === "number");
}
function isPortableTextToolkitList(block) {
  return block._type === "@list";
}
function isPortableTextToolkitSpan(span) {
  return span._type === "@span";
}
function isPortableTextToolkitTextNode(node) {
  return node._type === "@text";
}
const knownDecorators = ["strong", "em", "code", "underline", "strike-through"];
function sortMarksByOccurences(span, index, blockChildren) {
  if (!isPortableTextSpan(span) || !span.marks) {
    return [];
  }
  if (!span.marks.length) {
    return [];
  }
  const marks = span.marks.slice();
  const occurences = {};
  marks.forEach((mark) => {
    occurences[mark] = 1;
    for (let siblingIndex = index + 1; siblingIndex < blockChildren.length; siblingIndex++) {
      const sibling = blockChildren[siblingIndex];
      if (sibling && isPortableTextSpan(sibling) && Array.isArray(sibling.marks) && sibling.marks.indexOf(mark) !== -1) {
        occurences[mark]++;
      } else {
        break;
      }
    }
  });
  return marks.sort((markA, markB) => sortMarks(occurences, markA, markB));
}
function sortMarks(occurences, markA, markB) {
  const aOccurences = occurences[markA];
  const bOccurences = occurences[markB];
  if (aOccurences !== bOccurences) {
    return bOccurences - aOccurences;
  }
  const aKnownPos = knownDecorators.indexOf(markA);
  const bKnownPos = knownDecorators.indexOf(markB);
  if (aKnownPos !== bKnownPos) {
    return aKnownPos - bKnownPos;
  }
  return markA.localeCompare(markB);
}
function buildMarksTree(block) {
  var _a;
  const { children, markDefs = [] } = block;
  if (!children || !children.length) {
    return [];
  }
  const sortedMarks = children.map(sortMarksByOccurences);
  const rootNode = {
    _type: "@span",
    children: [],
    markType: "<unknown>"
  };
  let nodeStack = [rootNode];
  for (let i = 0; i < children.length; i++) {
    const span = children[i];
    if (!span) {
      continue;
    }
    const marksNeeded = sortedMarks[i] || [];
    let pos = 1;
    if (nodeStack.length > 1) {
      for (pos; pos < nodeStack.length; pos++) {
        const mark = ((_a = nodeStack[pos]) == null ? void 0 : _a.markKey) || "";
        const index = marksNeeded.indexOf(mark);
        if (index === -1) {
          break;
        }
        marksNeeded.splice(index, 1);
      }
    }
    nodeStack = nodeStack.slice(0, pos);
    let currentNode = nodeStack[nodeStack.length - 1];
    if (!currentNode) {
      continue;
    }
    for (const markKey of marksNeeded) {
      const markDef = markDefs.find((def) => def._key === markKey);
      const markType = markDef ? markDef._type : markKey;
      const node = {
        _type: "@span",
        _key: span._key,
        children: [],
        markDef,
        markType,
        markKey
      };
      currentNode.children.push(node);
      nodeStack.push(node);
      currentNode = node;
    }
    if (isPortableTextSpan(span)) {
      const lines = span.text.split("\n");
      for (let line = lines.length; line-- > 1; ) {
        lines.splice(line, 0, "\n");
      }
      currentNode.children = currentNode.children.concat(lines.map((text) => ({ _type: "@text", text })));
    } else {
      currentNode.children = currentNode.children.concat(span);
    }
  }
  return rootNode.children;
}
function nestLists(blocks, mode) {
  const tree = [];
  let currentList;
  for (let i = 0; i < blocks.length; i++) {
    const block = blocks[i];
    if (!block) {
      continue;
    }
    if (!isPortableTextListItemBlock(block)) {
      tree.push(block);
      currentList = void 0;
      continue;
    }
    if (!currentList) {
      currentList = listFromBlock(block, i, mode);
      tree.push(currentList);
      continue;
    }
    if (blockMatchesList(block, currentList)) {
      currentList.children.push(block);
      continue;
    }
    if ((block.level || 1) > currentList.level) {
      const newList = listFromBlock(block, i, mode);
      if (mode === "html") {
        const lastListItem = currentList.children[currentList.children.length - 1];
        const newLastChild = __spreadProps(__spreadValues({}, lastListItem), {
          children: [...lastListItem.children, newList]
        });
        currentList.children[currentList.children.length - 1] = newLastChild;
      } else {
        currentList.children.push(newList);
      }
      currentList = newList;
      continue;
    }
    if ((block.level || 1) < currentList.level) {
      const matchingBranch = tree[tree.length - 1];
      const match = matchingBranch && findListMatching(matchingBranch, block);
      if (match) {
        currentList = match;
        currentList.children.push(block);
        continue;
      }
      currentList = listFromBlock(block, i, mode);
      tree.push(currentList);
      continue;
    }
    if (block.listItem !== currentList.listItem) {
      const matchingBranch = tree[tree.length - 1];
      const match = matchingBranch && findListMatching(matchingBranch, { level: block.level || 1 });
      if (match && match.listItem === block.listItem) {
        currentList = match;
        currentList.children.push(block);
        continue;
      } else {
        currentList = listFromBlock(block, i, mode);
        tree.push(currentList);
        continue;
      }
    }
    console.warn("Unknown state encountered for block", block);
    tree.push(block);
  }
  return tree;
}
function blockMatchesList(block, list) {
  return (block.level || 1) === list.level && block.listItem === list.listItem;
}
function listFromBlock(block, index, mode) {
  return {
    _type: "@list",
    _key: `${block._key || `${index}`}-parent`,
    mode,
    level: block.level || 1,
    listItem: block.listItem,
    children: [block]
  };
}
function findListMatching(rootNode, matching) {
  const level = matching.level || 1;
  const style = matching.listItem || "normal";
  const filterOnType = typeof matching.listItem === "string";
  if (isPortableTextToolkitList(rootNode) && (rootNode.level || 1) === level && filterOnType && (rootNode.listItem || "normal") === style) {
    return rootNode;
  }
  if (!("children" in rootNode)) {
    return void 0;
  }
  const node = rootNode.children[rootNode.children.length - 1];
  return node && !isPortableTextSpan(node) ? findListMatching(node, matching) : void 0;
}
const leadingSpace = /^\s/;
const trailingSpace = /^\s/;
function toPlainText(block) {
  const blocks = Array.isArray(block) ? block : [block];
  let text = "";
  blocks.forEach((current, index) => {
    if (!isPortableTextBlock(current)) {
      return;
    }
    let pad = false;
    current.children.forEach((span) => {
      if (isPortableTextSpan(span)) {
        text += pad && text && !trailingSpace.test(text) && !leadingSpace.test(span.text) ? " " : "";
        text += span.text;
        pad = false;
      } else {
        pad = true;
      }
    });
    if (index !== blocks.length - 1) {
      text += "\n\n";
    }
  });
  return text;
}
function spanToPlainText(span) {
  let text = "";
  span.children.forEach((current) => {
    if (isPortableTextToolkitTextNode(current)) {
      text += current.text;
    } else if (isPortableTextToolkitSpan(current)) {
      text += spanToPlainText(current);
    }
  });
  return text;
}
const LIST_NEST_MODE_HTML = "html";
const LIST_NEST_MODE_DIRECT = "direct";

//# sourceMappingURL=portable-text-toolkit.mjs.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@portabletext/react/dist/react-portable-text.mjs
var react_portable_text_defProp = Object.defineProperty;
var react_portable_text_defProps = Object.defineProperties;
var react_portable_text_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var react_portable_text_getOwnPropSymbols = Object.getOwnPropertySymbols;
var react_portable_text_hasOwnProp = Object.prototype.hasOwnProperty;
var react_portable_text_propIsEnum = Object.prototype.propertyIsEnumerable;
var react_portable_text_defNormalProp = (obj, key, value) => key in obj ? react_portable_text_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var react_portable_text_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (react_portable_text_hasOwnProp.call(b, prop))
      react_portable_text_defNormalProp(a, prop, b[prop]);
  if (react_portable_text_getOwnPropSymbols)
    for (var prop of react_portable_text_getOwnPropSymbols(b)) {
      if (react_portable_text_propIsEnum.call(b, prop))
        react_portable_text_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var react_portable_text_spreadProps = (a, b) => react_portable_text_defProps(a, react_portable_text_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (react_portable_text_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && react_portable_text_getOwnPropSymbols)
    for (var prop of react_portable_text_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && react_portable_text_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};



function mergeComponents(parent, overrides) {
  const _a = overrides, { block, list, listItem, marks, types } = _a, rest = __objRest(_a, ["block", "list", "listItem", "marks", "types"]);
  return react_portable_text_spreadValues(react_portable_text_spreadProps(react_portable_text_spreadValues({}, parent), {
    block: mergeDeeply(parent, overrides, "block"),
    list: mergeDeeply(parent, overrides, "list"),
    listItem: mergeDeeply(parent, overrides, "listItem"),
    marks: mergeDeeply(parent, overrides, "marks"),
    types: mergeDeeply(parent, overrides, "types")
  }), rest);
}
function mergeDeeply(parent, overrides, key) {
  const override = overrides[key];
  const parentVal = parent[key];
  if (typeof override === "function") {
    return override;
  }
  if (override && typeof parentVal === "function") {
    return override;
  }
  if (override) {
    return react_portable_text_spreadValues(react_portable_text_spreadValues({}, parentVal), override);
  }
  return parentVal;
}
const react_portable_text_link = ({ children, value }) => /* @__PURE__ */ react.createElement("a", {
  href: value == null ? void 0 : value.href
}, children);
const underlineStyle = { textDecoration: "underline" };
const defaultMarks = {
  em: ({ children }) => /* @__PURE__ */ react.createElement("em", null, children),
  strong: ({ children }) => /* @__PURE__ */ react.createElement("strong", null, children),
  code: ({ children }) => /* @__PURE__ */ react.createElement("code", null, children),
  underline: ({ children }) => /* @__PURE__ */ react.createElement("span", {
    style: underlineStyle
  }, children),
  "strike-through": ({ children }) => /* @__PURE__ */ react.createElement("del", null, children),
  link: react_portable_text_link
};
const defaultLists = {
  number: ({ children }) => /* @__PURE__ */ react.createElement("ol", null, children),
  bullet: ({ children }) => /* @__PURE__ */ react.createElement("ul", null, children)
};
const DefaultListItem = ({ children }) => /* @__PURE__ */ react.createElement("li", null, children);
const getTemplate = (type, prop) => `Unknown ${type}, specify a component for it in the \`components.${prop}\` prop`;
const unknownTypeWarning = (typeName) => getTemplate(`block type "${typeName}"`, "types");
const unknownMarkWarning = (markType) => getTemplate(`mark type "${markType}"`, "marks");
const unknownBlockStyleWarning = (blockStyle) => getTemplate(`block style "${blockStyle}"`, "block");
const unknownListStyleWarning = (listStyle) => getTemplate(`list style "${listStyle}"`, "list");
const unknownListItemStyleWarning = (listStyle) => getTemplate(`list item style "${listStyle}"`, "listItem");
function printWarning(message) {
  console.warn(message);
}
const react_portable_text_hidden = { display: "none" };
const DefaultUnknownType = ({
  value,
  isInline
}) => {
  const warning = unknownTypeWarning(value._type);
  return isInline ? /* @__PURE__ */ react.createElement("span", {
    style: react_portable_text_hidden
  }, warning) : /* @__PURE__ */ react.createElement("div", {
    style: react_portable_text_hidden
  }, warning);
};
const DefaultUnknownMark = ({
  markType,
  children
}) => {
  return /* @__PURE__ */ react.createElement("span", {
    className: `unknown__pt__mark__${markType}`
  }, children);
};
const DefaultUnknownBlockStyle = ({
  children
}) => {
  return /* @__PURE__ */ react.createElement("p", null, children);
};
const DefaultUnknownList = ({ children }) => {
  return /* @__PURE__ */ react.createElement("ul", null, children);
};
const DefaultUnknownListItem = ({
  children
}) => {
  return /* @__PURE__ */ react.createElement("li", null, children);
};
const DefaultHardBreak = () => /* @__PURE__ */ react.createElement("br", null);
const defaultBlockStyles = {
  normal: ({ children }) => /* @__PURE__ */ react.createElement("p", null, children),
  blockquote: ({ children }) => /* @__PURE__ */ react.createElement("blockquote", null, children),
  h1: ({ children }) => /* @__PURE__ */ react.createElement("h1", null, children),
  h2: ({ children }) => /* @__PURE__ */ react.createElement("h2", null, children),
  h3: ({ children }) => /* @__PURE__ */ react.createElement("h3", null, children),
  h4: ({ children }) => /* @__PURE__ */ react.createElement("h4", null, children),
  h5: ({ children }) => /* @__PURE__ */ react.createElement("h5", null, children),
  h6: ({ children }) => /* @__PURE__ */ react.createElement("h6", null, children)
};
const defaultComponents = {
  types: {},
  block: defaultBlockStyles,
  marks: defaultMarks,
  list: defaultLists,
  listItem: DefaultListItem,
  hardBreak: DefaultHardBreak,
  unknownType: DefaultUnknownType,
  unknownMark: DefaultUnknownMark,
  unknownList: DefaultUnknownList,
  unknownListItem: DefaultUnknownListItem,
  unknownBlockStyle: DefaultUnknownBlockStyle
};
const PortableTextComponentsContext = (0,react.createContext)(defaultComponents);
const PortableTextComponentsProvider = ({
  components,
  children
}) => {
  const value = useMemo(() => mergeComponents(defaultComponents, components), [components]);
  return /* @__PURE__ */ React.createElement(PortableTextComponentsContext.Provider, {
    value
  }, children);
};
function PortableText({
  value: input,
  components: componentOverrides,
  listNestingMode,
  onMissingComponent: missingComponentHandler = printWarning
}) {
  const handleMissingComponent = missingComponentHandler || noop;
  const blocks = Array.isArray(input) ? input : [input];
  const nested = nestLists(blocks, listNestingMode || LIST_NEST_MODE_HTML);
  const parentComponents = (0,react.useContext)(PortableTextComponentsContext);
  const components = (0,react.useMemo)(() => {
    return componentOverrides ? mergeComponents(parentComponents, componentOverrides) : parentComponents;
  }, [parentComponents, componentOverrides]);
  const renderNode = (0,react.useMemo)(() => getNodeRenderer(components, handleMissingComponent), [components, handleMissingComponent]);
  const rendered = nested.map((node, index) => renderNode({ node, index, isInline: false, renderNode }));
  return componentOverrides ? /* @__PURE__ */ react.createElement(PortableTextComponentsContext.Provider, {
    value: components
  }, rendered) : /* @__PURE__ */ react.createElement(react.Fragment, null, rendered);
}
const getNodeRenderer = (components, handleMissingComponent) => {
  function renderNode(options) {
    const { node, index, isInline } = options;
    const key = node._key || `node-${index}`;
    if (isPortableTextToolkitList(node)) {
      return renderList(node, index, key);
    }
    if (isPortableTextListItemBlock(node)) {
      return renderListItem(node, index, key);
    }
    if (isPortableTextToolkitSpan(node)) {
      return renderSpan(node, index, key);
    }
    if (isPortableTextBlock(node)) {
      return renderBlock(node, index, key, isInline);
    }
    if (isPortableTextToolkitTextNode(node)) {
      return renderText(node, key);
    }
    return renderCustomBlock(node, index, key, isInline);
  }
  function renderListItem(node, index, key) {
    const tree = serializeBlock({ node, index, isInline: false, renderNode });
    const renderer = components.listItem;
    const handler = typeof renderer === "function" ? renderer : renderer[node.listItem];
    const Li = handler || components.unknownListItem;
    if (Li === components.unknownListItem) {
      const style = node.listItem || "bullet";
      handleMissingComponent(unknownListItemStyleWarning(style), {
        type: style,
        nodeType: "listItemStyle"
      });
    }
    let children = tree.children;
    if (node.style && node.style !== "normal") {
      const _a = node, { listItem } = _a, blockNode = __objRest(_a, ["listItem"]);
      children = renderNode({ node: blockNode, index, isInline: false, renderNode });
    }
    return /* @__PURE__ */ react.createElement(Li, {
      key,
      value: node,
      index,
      isInline: false,
      renderNode
    }, children);
  }
  function renderList(node, index, key) {
    const children = node.children.map((child, childIndex) => renderNode({
      node: child._key ? child : react_portable_text_spreadProps(react_portable_text_spreadValues({}, child), { _key: `li-${index}-${childIndex}` }),
      index,
      isInline: false,
      renderNode
    }));
    const component = components.list;
    const handler = typeof component === "function" ? component : component[node.listItem];
    const List = handler || components.unknownList;
    if (List === components.unknownList) {
      const style = node.listItem || "bullet";
      handleMissingComponent(unknownListStyleWarning(style), { nodeType: "listStyle", type: style });
    }
    return /* @__PURE__ */ react.createElement(List, {
      key,
      value: node,
      index,
      isInline: false,
      renderNode
    }, children);
  }
  function renderSpan(node, _index, key) {
    const { markDef, markType, markKey } = node;
    const Span = components.marks[markType] || components.unknownMark;
    const children = node.children.map((child, childIndex) => renderNode({ node: child, index: childIndex, isInline: true, renderNode }));
    if (Span === components.unknownMark) {
      handleMissingComponent(unknownMarkWarning(markType), { nodeType: "mark", type: markType });
    }
    return /* @__PURE__ */ react.createElement(Span, {
      key,
      text: spanToPlainText(node),
      value: markDef,
      markType,
      markKey,
      renderNode
    }, children);
  }
  function renderBlock(node, index, key, isInline) {
    const _a = serializeBlock({ node, index, isInline, renderNode }), { _key } = _a, props = __objRest(_a, ["_key"]);
    const style = props.node.style || "normal";
    const handler = typeof components.block === "function" ? components.block : components.block[style];
    const Block = handler || components.unknownBlockStyle;
    if (Block === components.unknownBlockStyle) {
      handleMissingComponent(unknownBlockStyleWarning(style), {
        nodeType: "blockStyle",
        type: style
      });
    }
    return /* @__PURE__ */ react.createElement(Block, react_portable_text_spreadProps(react_portable_text_spreadValues({
      key
    }, props), {
      value: props.node,
      renderNode
    }));
  }
  function renderText(node, key) {
    if (node.text === "\n") {
      const HardBreak = components.hardBreak;
      return HardBreak ? /* @__PURE__ */ react.createElement(HardBreak, {
        key
      }) : "\n";
    }
    return node.text;
  }
  function renderCustomBlock(node, index, key, isInline) {
    const Node = components.types[node._type];
    const nodeOptions = {
      value: node,
      isInline,
      index,
      renderNode
    };
    if (Node) {
      return /* @__PURE__ */ react.createElement(Node, react_portable_text_spreadValues({
        key
      }, nodeOptions));
    }
    handleMissingComponent(unknownTypeWarning(node._type), { nodeType: "block", type: node._type });
    const UnknownType = components.unknownType;
    return /* @__PURE__ */ react.createElement(UnknownType, react_portable_text_spreadValues({
      key
    }, nodeOptions));
  }
  return renderNode;
};
function serializeBlock(options) {
  const { node, index, isInline, renderNode } = options;
  const tree = buildMarksTree(node);
  const children = tree.map((child, i) => renderNode({ node: child, isInline: true, index: i, renderNode }));
  return {
    _key: node._key || `block-${index}`,
    children,
    index,
    isInline,
    node
  };
}
function noop() {
}

//# sourceMappingURL=react-portable-text.mjs.map


/***/ })

}]);